import { render, staticRenderFns } from "./instruction_en.vue?vue&type=template&id=6e99eca3&scoped=true"
import script from "./instruction_en.vue?vue&type=script&lang=js"
export * from "./instruction_en.vue?vue&type=script&lang=js"
import style0 from "./instruction_en.vue?vue&type=style&index=0&id=6e99eca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99eca3",
  null
  
)

export default component.exports